import { defineStore } from 'pinia'
import { toast } from 'vue-sonner'
import { feedbacksApi as api } from '@/api/endpoints/feedbacks'
import { invalidateList } from '@/queries/storeCache'
import { commonGetters } from '@/stores/commonGetters.js'

export const useFeedbacksStore = defineStore('feedbacks', {
  getters: {
    ...commonGetters,
  },
  actions: {
    async GetFeedbacks(params) {
      const body = await api.list(this.workspace_id, params)
      return body.data
    },

    async GetFeedback(feedbackId) {
      const body = await api.get(this.workspace_id, feedbackId)
      return body.data?.feedback ?? body.data
    },

    async CreateFeedback(payload) {
      const body = await api.create(this.workspace_id, payload)
      toast.success(body.message ?? 'Feedback submitted successfully')
      invalidateList('feedbacks')
      return body.data
    },

    async GetFeedbackMeta() {
      const body = await api.meta(this.workspace_id)
      return body.data
    },

    // Admin (global) feedbacks
    async GetAdminFeedbacks(params) {
      const body = await api.adminList(params)
      return body.data
    },

    async GetAdminFeedback(feedbackId) {
      const body = await api.adminGet(feedbackId)
      return body.data?.feedback ?? body.data
    },

    async UpdateAdminFeedback(feedbackId, payload) {
      const body = await api.adminUpdate(feedbackId, payload)
      toast.success(body.message ?? 'Feedback updated successfully')
      invalidateList('admin-feedbacks')
      return body.data?.feedback ?? body.data
    },

    async GetAdminFeedbackMeta() {
      const body = await api.adminMeta()
      return body.data
    },

    async CreateFeedbackComment(feedbackId, payload, workspaceId = null) {
      const body = await api.addComment(workspaceId ?? this.workspace_id, feedbackId, payload)
      toast.success(body.message ?? 'Comment added successfully')
      invalidateList('feedbacks')
      return body.data
    },
  },
})
